const moneyCents = (value) => Math.round((Number(value) || 0) * 100);

const MRALLINONE_LOBBY_REQUIRED_MESSAGE = 'Return to the Mr All In One game lobby, then refresh your balance and try withdrawing again.';
const REDEEM_CONFIRMATION_UNAVAILABLE_MESSAGE = 'Withdrawal confirmation is unavailable. Do not withdraw again yet; contact support to check this request.';

// Only display recognized recovery copy, never arbitrary upstream error text.
export const redeemRecoveryMessage = (detail) => {
  const message = String(detail || '').trim();
  if (message === MRALLINONE_LOBBY_REQUIRED_MESSAGE) return MRALLINONE_LOBBY_REQUIRED_MESSAGE;
  if (message === REDEEM_CONFIRMATION_UNAVAILABLE_MESSAGE || message.startsWith('Redeem confirmation is unavailable. Do not repeat this withdrawal;')) {
    return REDEEM_CONFIRMATION_UNAVAILABLE_MESSAGE;
  }
  return null;
};

export const errorClaimsWalletShortfall = ({ detail, failureCode } = {}) => {
  const normalizedCode = String(failureCode || '').trim().toLowerCase();
  if (['wallet_insufficient_funds', 'insufficient_wallet_balance'].includes(normalizedCode)) return true;
  const normalizedDetail = String(detail || '').toLowerCase();
  return normalizedDetail.includes('insufficient')
    || normalizedDetail.includes('no balance')
    || normalizedDetail.includes('not enough');
};

export const shouldShowWalletShortfall = ({ detail, failureCode, available, requested } = {}) => (
  errorClaimsWalletShortfall({ detail, failureCode })
  && moneyCents(available) < moneyCents(requested)
);
